import { useOutletContext } from 'react-router-dom';

import { LegalAgreementHtmlBlock } from '../widget-ui/legal-agreement-html-block';
import { formatISODate } from '../widget-lib/format-date';
import { useWidgetSeo } from '../widget-hooks/use-widget-seo';
import type { LegalDocumentsOutletContext } from './legal_LegalDocumentsOutlet';

export default function LegalCrmPage() {
  useWidgetSeo(
    'Пользовательское соглашение',
    'Пользовательское соглашение и публичная оферта использования сервиса DomCRM.'
  );
  const { data } = useOutletContext<LegalDocumentsOutletContext>();
  return (
    <article className="space-y-4 w-full min-w-0 px-4 py-4">
      <h1 className="text-xl font-semibold tracking-tight">Публичная оферта</h1>
      {data.CrmUserAgreementDate && (
        <p className="text-xs text-[var(--text-muted)]">от {formatISODate(data.CrmUserAgreementDate)}</p>
      )}
      <LegalAgreementHtmlBlock html={data.CrmUserAgreementText} />
    </article>
  );
}
